import { useQuery } from "@tanstack/react-query";
import { getCompanySettingsApi } from "@/core/api/api.service";

export interface CompanySettings {
    description: string;
    contactEmail: string;
    contactPhone: string;
    address1: string;
    timeZone: string;
    logo: string;
    url: string;
    address2: string;
    address3: string;
    address4: string;
    address5: string | null;
    address6: string | null;
}

export const useCompanySettings = () => {
    const { data, isLoading, error } = useQuery<CompanySettings>({
        queryKey: ["companySettings"],
        queryFn: async () => {
            const response = await getCompanySettingsApi();
            return response.data as CompanySettings;
        },
        staleTime: Infinity, // Never refetch unless manually triggered
        gcTime: Infinity, // Keep in cache forever
    });

    return {
        data: data ?? null,
        isLoading,
        error,
    };
};